// extracted by mini-css-extract-plugin
export default {"root":"WebhookSection_root__DiVM+","content":"WebhookSection_content__hSqU8","info":"WebhookSection_info__l6W3I"};